import { DataGrid } from '@mui/x-data-grid'
import {
  Box,
  Button,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  FormControlLabel,
  FormGroup,
  IconButton, Snackbar,
  Switch,
  Toolbar,
  Typography,
} from '@mui/material'

import ClearIcon from '@mui/icons-material/Clear'
import EditIcon from '@mui/icons-material/Edit'
import PersonAddIcon from '@mui/icons-material/PersonAdd';

import '../../css/usertable.css'
import {getTimeStringForView} from '../util/componentutil.js';


import { useEffect, useState } from 'react'


/**
 * @param props
 * create/update/delete

 */

const UserTable = (props) => {



  //pageあたりの個数
  const [pageSize, setPageSize] = useState(5);

  const [dialogOpen,setDialogOpen] = useState(false);
  const [targetRow,setTargetRow] = useState();



  // ActionのUIをレンダリングする
  const actionRender = (params) => {
    return (
      <>
        <EditIconButton data={params.row} />
        <DeleteIconButton data={params.row} />
        <AvailableSwitch data={params.row} />
        <PasswordResetButton data={params.row} />
      </>
    )
  }

  // 編集ボタン　dataに対象データを設定する
  const EditIconButton = (props) => {
    return (
      <IconButton onClick={(e) => onEdit(props.data)}>
        <EditIcon />
      </IconButton>
    )
  }

  // 削除ボタン　dataに対象データを設定する
  const DeleteIconButton = (props) => {
    return (
      <IconButton onClick={(e) => onDelete(props.data)}>
        <ClearIcon />
      </IconButton>
    )
  }

  // 有効・無効ボタン　dataに対象データを設定する
  const AvailableSwitch = (props) => {
    return (
      <>
        <FormGroup>
          {props.data.isAvailable ?
            <FormControlLabel onChange={(e) => onAvailableLabel(props.data)} control={<Switch defaultChecked />} label="有効" /> :
            <FormControlLabel onChange={(e) => onAvailableLabel(props.data)} control={<Switch />} label="有効" />
          }

        </FormGroup>
      </>
    );
  }

  //パスワードリセットボタン
  const PasswordResetButton = (props) => {
    return (
      <>
        <Button onClick={(e) => onReset(props) } variant={"outlined"}>リセット</Button>
      </>
    );
  }

  //削除処理　上位コンポーネントの削除を呼び出す（確認Alertなどはここに追加)
  const onDelete = (params) => {
    props.delete(params)
  }


  //削除処理　上位コンポーネントの更新を呼び出す
  const onEdit = (params) => {
    props.update(params)
  }

  //新規処理　上位コンポーネントの新規を呼び出す
  const onNew = (params) => {
    props.create(params);
  }

  //有効化・無効化
  const onAvailableLabel = (params) => {
    props.available(params);
  }

  //リセットボタンのハンドラー（ダイアログを出す）
  const onReset = (params) => {
    setTargetRow(params);
    setDialogOpen(true);
  };

  const dialogCancel = (e) => {
    setDialogOpen(false);
  }

  const dialogResetDone = (e) => {
    setDialogOpen(false);
    props.passreset(targetRow);
  }


  //描画のためのラベル選択
  const getLabelforAvailable = (params) => {
    return params.row.isAvailable ? '有効' : '無効'
  }

  const getLabelforDatetime = (params) => {
    return getTimeStringForView(params.row.entrytime)
  }


  //テナントのマッピング
  const getLabelforTenant = (params) => {
    const tenant = props.tenantlist.filter((item) => {
      return item.name == params.row.tenantid ? true : false
    });

    if(tenant[0]){
      return tenant[0].name;
    }else{
      return "Deleted";
    }


  }

  //カラム設定
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 30,
      headerClassName: 'header-styles',
    },
    {
      field: 'uid',
      headerName: 'ユーザID',
      width: 190,
      headerClassName: 'header-styles',
    },
    {
      field: 'tenantid',
      headerName: 'テナント',
      width: 150,
      headerClassName: 'header-styles',
      valueGetter: getLabelforTenant,
    },
    {
      field: 'familyname',
      headerName: '姓',
      width: 100,
      headerClassName: 'header-styles',
    },
    {
      field: 'lastname',
      headerName: '名',
      width: 100,
      headerClassName: 'header-styles',
    },
    {
      field: 'email',
      headerName: 'メールアドレス',
      width: 200,
      headerClassName: 'header-styles',
    },
    {
      field: 'isAvailable',
      headerName: '有効',
      width: 50,
      headerClassName: 'header-styles',
      valueGetter: getLabelforAvailable,
    },
    {
      field: 'entrytime',
      headerName: '登録日時',
      width: 155,
      headerClassName: 'header-styles',
      valueGetter: getLabelforDatetime,
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 270,
      headerClassName: 'header-styles',
      renderCell: (params) => actionRender(params),
    },
  ]

  //JSX
  return (
    <>
      <Box sx={{ml:0,mb:1}}>
        <Button variant="contained" onClick={(e) => onNew({})} startIcon={<PersonAddIcon />} sx={{m:0}}>
          <Typography variant={"body"}>新規ユーザ作成</Typography>
        </Button>
      </Box>
      <Box sx={{ height: 372, width: '1268px' }}>
        <DataGrid
          rows={props.data}
          rowHeight={40}
          loading={props.loading}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[2, 5, 10,100]}
          rowSpacingType='border'
          experimentalFeatures={{ newEditingApi: true }}
          sx={{ color: '#939191' }}
        />
      </Box>

      <Dialog open={dialogOpen}>
        <DialogTitle >確認</DialogTitle>
        <DialogContent>
          <DialogContentText>
            パスワードをリセットしますがよろしいですか？
          </DialogContentText>
          <DialogActions>
            <Button onClick={dialogResetDone}>リセット実行</Button>
            <Button onClick={dialogCancel}>キャンセル</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  )


}

export default UserTable